<template>
  <div class="buttonsNav">
    <button class="back-button" v-on:click.prevent="$emit('stepBack')">
      <icon class="icon" icon="back.svg"></icon>
    </button>
    <button class="continue-button" v-on="$listeners">
      <icon class="icon" icon="check.svg"></icon>
      <div class="continue-button__text">
        {{ text }}
      </div>
    </button>
  </div>
</template>

<script>
import Icon from './icon'

export default {
  props: {
    text: String,
    checkmark: Boolean
  },
  components: { Icon }
}
</script>

<style lang="scss" scoped>
.buttonsNav{
  display: flex;
  justify-content: left;
}

.back-button {
  display: flex;
  justify-content: space-evenly;

  height: min-content;
  width: calc(33.3333% - #{$block-margin} * 2);

  margin: $block-margin;
  padding: 10px 0;

  background-color: color('submitbutton');

  font-size: 1em;
  font-weight: bold;

  transition: filter 0.5s, opacity 0.5s;

  &:hover {
    background-color: darken(color('submitbutton'), 10%);
  }

  &:disabled {
    transition: filter 0.5s, opacity 0.5s;
    filter: grayscale(100%);
    opacity: 0.8;
    pointer-events: none;
  }
}

.continue-button {
  display: flex;
  justify-content: space-evenly;

  height: min-content;
  width: calc(100% - #{$block-margin} * 2);

  margin: $block-margin;
  padding: 10px 0;

  background-color: color('submitbutton');

  font-size: 1em;
  font-weight: bold;

  transition: filter 0.5s, opacity 0.5s;

  word-wrap: break-word;
  white-space: normal !important;

  &:hover {
    background-color: darken(color('submitbutton'), 10%);
  }

  &:disabled {
    transition: filter 0.5s, opacity 0.5s;
    filter: grayscale(100%);
    opacity: 0.8;
    pointer-events: none;
  }
}

.icon {
  height: 3em;
  align-self: center;
}

.continue-button__text {
  height: min-content;
  width: min-content;
  align-self: center;
}
</style>
